<template>
    <div class="card shadow rounded-custom overflow-hidden w-100 h-100">

      <div class="card-header rounded-only-top bg-dark-violet p-3 text-center">
        <h3 class="text-white text-uppercase m-0">
          <!--        &lt;!&ndash; TODO link tot page &ndash;&gt;-->
          <!--        <img class="float-start" src="@/assets/icons/more-info.svg" width="50" alt="more-info"/>-->
          ordini in entrata
        </h3>
      </div>

      <div class="card-body p-0 overflow-auto">
        <div v-if="showTagColumn" class="d-flex justify-content-end align-items-center p-2 bg-light-violet">
          <label class="text-uppercase fw-bold me-2 mb-0">Ordina per</label>
          <select v-model="selectedOrderSortField" class="form-select form-select-sm w-auto text-uppercase">
            <option :value="warehouseOrderSortFields.TAG">tag</option>
            <option :value="warehouseOrderSortFields.DATE">data</option>
          </select>
        </div>

        <div class="table-responsive h-100">
          <table class="table">
            <thead>
              <tr>
                <th v-if="showTagColumn">tag</th>
                <th><InputSearchMinimal :name="'prescrizione'" @termToSearch="prescriptionTerm"/></th>
                <th><InputSearchMinimal :name="'data'" @termToSearch="dataTerm"/></th>
                <th><InputSearchMinimal :name="'tecnico'" @termToSearch="technicianTerm"/></th>
                <th>quantità</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(order, index) in visiblePendingOrderRows" :key="index">
                <OrderPending
                  :data="order"
                  :showTagColumn="showTagColumn"
                  @selected="readSelected"
                />
              </template>
            </tbody>
          </table>
          <template v-if="visiblePendingOrderRows.length === 0">
            <div class="d-flex justify-content-center align-items-center w-100 h-100">
              <h3 class="text-center">Nessun ordine in entrata presente</h3>
            </div>
          </template>
        </div>

      </div>
    </div>

</template>

<script>
import {inject, onMounted, ref, watch, toRaw, getCurrentInstance, onUnmounted} from "vue";
import _ from "lodash";
import moment from "moment";

import OrderPending from "@/components/warehouse/supervisor/OrderPending";
import InputSearchMinimal from "@/components/InputSearchMinimal";

import {warehouseRequest} from '@/use/repositories/testWorkQueue/warehouseRequest';

const warehouseOrderSortFields = {
  DATE: "date",
  TAG: "tag",
};

const warehouseRequestStates = {
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
};

export default {
  name: "RequestedOrders",
  props: {
    resetSelection: {
      type: Boolean,
      required: true,
    },
    showTagColumn: {
      type: Boolean,
      default: false,
    },
    warehouseRequestFilters: {
      type: Object,
      default: () => ({}),
    },
    excludedSourceDepartmentSlugs: {
      type: Array,
      default: () => [],
    },
    defaultOrderSortField: {
      type: String,
      default: warehouseOrderSortFields.DATE,
    },
  },
  components: {
    OrderPending,
    InputSearchMinimal
  },
  emits: [
    'orderDetails',
    'updateApprovedOrders',
    'resetComplete',
    'resetOrderDetails',
  ],
  setup(props, {emit}) {
    const { departments } = inject("constants");
    const warehouseOrderRows = ref([]);
    const visiblePendingOrderRows = ref([]);
    const warehouseOrderRowsByState = ref({
      pending: [],
      approved: [],
    });
    // To search.
    const prescription = ref("");
    const data = ref("");
    const technician = ref("");
    const selectedOrderSortField = ref(props.defaultOrderSortField);
    // Pusher.
    const internalInstance = getCurrentInstance();
    const pusher = internalInstance.appContext.config.globalProperties.$pusher;

    watch(() => props.resetSelection, (toResetSelection) => {
      if (toResetSelection) {
        visiblePendingOrderRows.value.forEach((order) => {
          order.selected = false;
        });

        emit('resetComplete', false);
      }
    });

    onMounted(() => {
      warehouseRequest([warehouseRequestStates.PENDING, warehouseRequestStates.APPROVED], props.warehouseRequestFilters).then((response) => {
        response.orders.value.map((testWorkQueue) => {
          testWorkQueue.test_work_queue_phases.map((testWorkQueuePhase) => {
            if (isOrderRowAllowedForThisDashboard(testWorkQueuePhase)) {
              warehouseOrderRows.value.push(buildWarehouseOrderRow(testWorkQueuePhase, testWorkQueue));
            }
          });
        });

        warehouseOrderRows.value = sortOrderRows(toRaw(warehouseOrderRows.value));

        // Filter by state.
        warehouseOrderRowsByState.value.pending = filterByState(toRaw(warehouseOrderRows.value), warehouseRequestStates.PENDING);
        visiblePendingOrderRows.value = warehouseOrderRowsByState.value.pending; // Create copy for filtered.
        warehouseOrderRowsByState.value.approved = filterByState(toRaw(warehouseOrderRows.value), warehouseRequestStates.APPROVED);

        if (warehouseOrderRowsByState.value.approved.length > 0) {
          emit('updateApprovedOrders', warehouseOrderRowsByState.value.approved);
        }
      });

      // Subscribe to channel.
      subscribe("private-live", "warehouse-request_change-state");
    });

    const filterByState = (array, stateSlug) => {
      return array.map(testWorkQueue => {
        const articles = testWorkQueue.articles.filter(article => article.state.slug === stateSlug);
        if (articles.length) {
          return { ...testWorkQueue, articles };
        }
        return null;
      }).filter(item => item);
    }

    onUnmounted(() => {
      console.log("unmount");
      unsubscribeChannel("private-live");
    });

    const removeOrderFromCollection = (collection, order) => {
      let testWokQueuePhaseIndex = collection.findIndex(item => item.id === order.test_work_queue_phase.id);

      if (testWokQueuePhaseIndex !== -1) {
        let articleIndex = collection[testWokQueuePhaseIndex].articles.findIndex(item => item.id === order.id);
        if (articleIndex !== -1) {
          collection[testWokQueuePhaseIndex].articles.splice(articleIndex, 1);

          // Remove testWorkQueuePhase if empty.
          if (collection[testWokQueuePhaseIndex].articles.length === 0) {
            collection.splice(testWokQueuePhaseIndex, 1);
          }
        }
      }
    }

    const removeFromPending = (order) => {
      removeOrderFromCollection(visiblePendingOrderRows.value, order);
      removeOrderFromCollection(warehouseOrderRowsByState.value.pending, order);
    }

    const updateOrCreateOrder = (order, state_slug) => {
      if (!isLiveWarehouseRequestAllowedForThisDashboard(order)) {
        return;
      }

      if (state_slug === warehouseRequestStates.REJECTED) {
        return removeFromPending(order);
      }

      // Check if test work queue is already in the list.
      let testWokQueuePhaseIndex = warehouseOrderRowsByState.value[state_slug].findIndex((o) => o.id === order.test_work_queue_phase.id);

      if (order.approved_quantity === null) {
        order.approved_quantity = order.requested_quantity;
      }

      // Create order if not found.
      if (testWokQueuePhaseIndex === -1) {
        let testWorkQueue = {
          id: order.test_work_queue_phase.id,
          articles: [order],
          date: getFormattedPriorityDate(order.test_work_queue_phase.test_work_queue),
          raw_date: order.test_work_queue_phase.test_work_queue.delivery_date,
          department: getDepartmentLabel(order.test_work_queue_phase),
          number_text: getPrescriptionNumberText(order.test_work_queue_phase, order.test_work_queue_phase.test_work_queue),
          tag: getTagLabel(order.test_work_queue_phase, order.test_work_queue_phase.test_work_queue),
          selected: false,
          technician: `${order.user.first_name} ${order.user.last_name}`,
        };

        // Add new order.
        warehouseOrderRowsByState.value[state_slug].push(testWorkQueue);
      } else {
        let articleIndex = warehouseOrderRowsByState.value[state_slug][testWokQueuePhaseIndex].articles.findIndex((a) => a.id === order.id);

        // Article not exists.
        if (articleIndex === -1) {
          warehouseOrderRowsByState.value[state_slug][testWokQueuePhaseIndex].articles.push(order);
        } else {
          warehouseOrderRowsByState.value[state_slug][testWokQueuePhaseIndex].articles[articleIndex] = order;
        }
      }

      // Remove from pending.
      if (state_slug === warehouseRequestStates.APPROVED) {
        removeFromPending(order);
      }

      // Sort by priority date.
      warehouseOrderRowsByState.value[state_slug] = sortOrderRows(toRaw(warehouseOrderRowsByState.value[state_slug]));

      // Update approved orders.
      if (state_slug === warehouseRequestStates.APPROVED) {
        emit('updateApprovedOrders', warehouseOrderRowsByState.value[warehouseRequestStates.APPROVED]);
      }

      applyPendingFilters();
    }

    // Subscribe to channel
    const subscribe = (channelName, eventName) => {
      console.log(`subscribing from "${channelName}"...`, {
        $pusher: pusher,
      });
      const channel = pusher.subscribe(channelName);
      channel.bind("pusher:subscription_succeeded", () => console.log("subscription succeeded"));
      channel.bind(eventName, async (event) => {
        console.log("event received", event);
        updateOrCreateOrder(event.warehouse_request, event.state_slug);
      });
    };

    // Unsubscribe to channel
    const unsubscribeChannel = (channelName) => {
      console.log(`unsubscribing from "${channelName}"...`, {
        $pusher: pusher,
      });
      console.log("unsubscribing...");
      pusher.unsubscribe(channelName);
    };

    const buildWarehouseOrderRow = (testWorkQueuePhase, testWorkQueue) => {
        let articles = testWorkQueuePhase.warehouse_requests.map((order) => {
            if (order.approved_quantity === null) {
              return {
                ...order,
                approved_quantity: order.requested_quantity,
              }
            } else {
              return {
                ...order,
              };
            }
          });

        return {
          id: testWorkQueuePhase.id,
          selected: false,
          technician: getRequesterLabel(testWorkQueuePhase),
          department: getDepartmentLabel(testWorkQueuePhase),
          date: getFormattedPriorityDate(testWorkQueue),
          raw_date: testWorkQueue.delivery_date,
          number_text: getPrescriptionNumberText(testWorkQueuePhase, testWorkQueue),
          tag: getTagLabel(testWorkQueuePhase, testWorkQueue),
          articles: articles,
        }
    }

    const getPrescriptionNumberText = (testWorkQueuePhase, testWorkQueue) => {
      if (testWorkQueuePhase.department.slug === departments.CAM) {
        return '-';
      }

      return testWorkQueue.prescription?.number_text ||
        testWorkQueue.prescription_test?.prescription?.number_text ||
        '-';
    }

    const normalize = (value) => {
      return String(value || "").toLowerCase();
    }

    const normalizeDepartmentSlug = (value) => {
      return normalize(value).replace(/\s+/g, "-");
    }

    const applyPendingFilters = () => {
      // Clear data on details order box.
      emit('resetOrderDetails');
      // Reset selected.
      visiblePendingOrderRows.value.forEach((order) => order.selected = false);

      visiblePendingOrderRows.value = sortOrderRows(warehouseOrderRowsByState.value.pending.filter((order) => {
        return normalize(order.number_text).includes(normalize(prescription.value)) &&
          normalize(order.date).includes(normalize(data.value)) &&
          normalize(order.technician).includes(normalize(technician.value));
      }));
    }

    // Watcher listeners.
    watch([prescription, data, technician, selectedOrderSortField], applyPendingFilters);

    const firstFilled = (values) => {
      return values.find((value) => value !== undefined && value !== null && value !== "") || "-";
    }

    const getTagLabel = (testWorkQueuePhase, testWorkQueue) => {
      return firstFilled([
        testWorkQueue.device?.name,
        testWorkQueuePhase.tag,
        testWorkQueuePhase.tag_number,
        testWorkQueuePhase.device?.name,
        testWorkQueuePhase.prescription_test?.device?.name,
        testWorkQueue.prescription_test?.device?.name,
        testWorkQueue.prescription?.prescription_test?.device?.name,
        testWorkQueue.prescription?.prescription_tests?.[0]?.device?.name,
      ]);
    }

    const getSortValue = (order) => {
      if (selectedOrderSortField.value === warehouseOrderSortFields.TAG) {
        return order.tag;
      }

      return order.raw_date || order.date;
    }

    const sortOrderRows = (items) => {
      return _.orderBy(items, [(item) => normalize(getSortValue(item))], ['asc']);
    }

    const getSourceDepartmentSlug = (warehouseRequest) => {
      return firstFilled([
        warehouseRequest.source_department_slug,
        warehouseRequest.source_department?.slug,
        warehouseRequest.source_department?.name,
        warehouseRequest.department?.slug,
        warehouseRequest.department?.name,
      ]);
    }

    const getNormalizedExcludedSourceDepartmentSlugs = () => {
      return props.excludedSourceDepartmentSlugs.map(normalizeDepartmentSlug);
    }

    const getOrderSourceDepartmentCandidates = (testWorkQueuePhase) => {
      return [
        testWorkQueuePhase.source_department_slug,
        testWorkQueuePhase.source_department?.slug,
        testWorkQueuePhase.source_department?.name,
        testWorkQueuePhase.department?.slug,
        testWorkQueuePhase.department?.name,
        ...(testWorkQueuePhase.warehouse_requests || []).map(getSourceDepartmentSlug),
      ].map(normalizeDepartmentSlug);
    }

    const getLiveOrderSourceDepartmentCandidates = (warehouseRequest) => {
      return [
        warehouseRequest.source_department_slug,
        warehouseRequest.source_department?.slug,
        warehouseRequest.source_department?.name,
        warehouseRequest.department?.slug,
        warehouseRequest.department?.name,
        warehouseRequest.test_work_queue_phase?.source_department_slug,
        warehouseRequest.test_work_queue_phase?.source_department?.slug,
        warehouseRequest.test_work_queue_phase?.source_department?.name,
        warehouseRequest.test_work_queue_phase?.department?.slug,
        warehouseRequest.test_work_queue_phase?.department?.name,
      ].map(normalizeDepartmentSlug);
    }

    const containsExcludedSourceDepartment = (sourceDepartmentCandidates) => {
      const excludedSourceDepartmentSlugs = getNormalizedExcludedSourceDepartmentSlugs();

      if (!excludedSourceDepartmentSlugs.length) {
        return false;
      }

      return sourceDepartmentCandidates.some((sourceDepartmentCandidate) => {
        return excludedSourceDepartmentSlugs.includes(sourceDepartmentCandidate);
      });
    }

    const isOrderRowFromRequestedSourceDepartment = (testWorkQueuePhase) => {
      const sourceDepartmentSlug = normalizeDepartmentSlug(props.warehouseRequestFilters.source_department_slug);

      if (!sourceDepartmentSlug) {
        return true;
      }

      return getOrderSourceDepartmentCandidates(testWorkQueuePhase).includes(sourceDepartmentSlug);
    }

    const isOrderRowAllowedForThisDashboard = (testWorkQueuePhase) => {
      const sourceDepartmentCandidates = getOrderSourceDepartmentCandidates(testWorkQueuePhase);

      return isOrderRowFromRequestedSourceDepartment(testWorkQueuePhase) &&
        !containsExcludedSourceDepartment(sourceDepartmentCandidates);
    }

    const isLiveWarehouseRequestFromRequestedSourceDepartment = (warehouseRequest) => {
      const sourceDepartmentSlug = normalizeDepartmentSlug(props.warehouseRequestFilters.source_department_slug);

      if (!sourceDepartmentSlug) {
        return true;
      }

      return getLiveOrderSourceDepartmentCandidates(warehouseRequest).includes(sourceDepartmentSlug);
    }

    const isLiveWarehouseRequestAllowedForThisDashboard = (warehouseRequest) => {
      const sourceDepartmentCandidates = getLiveOrderSourceDepartmentCandidates(warehouseRequest);

      return isLiveWarehouseRequestFromRequestedSourceDepartment(warehouseRequest) &&
        !containsExcludedSourceDepartment(sourceDepartmentCandidates);
    }

    const getRequesterLabel = (testWorkQueuePhase) => {
      return `${_.head(testWorkQueuePhase.warehouse_requests)?.user?.first_name} ${_.head(testWorkQueuePhase.warehouse_requests)?.user?.last_name}`;
    }

    const getDepartmentLabel = (testWorkQueuePhase) => {
      return testWorkQueuePhase.department?.name || testWorkQueuePhase.department?.slug || '-';
    }

    const getFormattedPriorityDate = (testWorkQueue) => {
      return moment(testWorkQueue.delivery_date).utc(0).format('DD/MM/YYYY HH:mm:ss');
    }

    const prescriptionTerm = (term) => { prescription.value = term }
    const dataTerm = (term) => { data.value = term }
    const technicianTerm = (term) => { technician.value = term }

    const readSelected = (orderSelected) => {
      visiblePendingOrderRows.value.forEach((order) => {
        order.selected = order.id === orderSelected.id;
      });

      emit('orderDetails', {
        order: orderSelected,
        readOnlyMode: false
      });
    }

    return {
      prescriptionTerm,
      dataTerm,
      technicianTerm,
      prescription,
      data,
      technician,
      readSelected,
      warehouseOrderRows,
      warehouseOrderRowsByState,
      visiblePendingOrderRows,
      selectedOrderSortField,
      warehouseOrderSortFields,
    }
  }
}
</script>
<style scoped>
.table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #E1D2F2;
}
tr th,
tr td {
  text-align: center;
  border: 0;
  padding: 1em;
  text-transform: uppercase;
}
</style>
